export type DriverLicenceComponentValue = string | null;
export type DriverLicenceCardNumberComponentValue = string | null;